import { render, staticRenderFns } from "./RecentGames.vue?vue&type=template&id=313d6781&scoped=true&"
import script from "./RecentGames.vue?vue&type=script&lang=js&"
export * from "./RecentGames.vue?vue&type=script&lang=js&"
import style0 from "./RecentGames.vue?vue&type=style&index=0&id=313d6781&lang=scss&scoped=true&"
import style1 from "./RecentGames.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313d6781",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
